import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { runInThisContext } from 'vm';
import { LoanProfitabilityDialogComponent } from '../../shared/components/loan-profitability-dialog/loan-profitability-dialog.component';
import {
    IDialogParams,
    ILoanProfitabilitySummary,
    IProfitabilityDataModel,
    IProfitabilityIncomeStatement,
    IProfitabilityParams,
    IRouteHistoryParams,
} from '../interfaces/profitability-data';

@Injectable({
    providedIn: 'root',
})
export class ProfitabilityService {
    private serverUrl = 'https://' + window.location.host; // TODO Get url and version number from appsettings.
    private version = '0.5';
    private _url = (this.serverUrl + '/api/v{version}/Profitability/').replace(
        '{version}',
        this.version
    );
    private hasRouteHistory = false;
    private routeHistoryData: IRouteHistoryParams = {
        navigationLinks: [],
        hierarchy: '',
        identifier: '',
        titlePart: '',
    };

    dialogParametrs: IDialogParams;

    constructor(private _http: HttpClient, private dialog: MatDialog) {}

    getGLLOInsightsCard(parameters: IProfitabilityParams): Observable<IProfitabilityDataModel[]> {
        return this._http.post<IProfitabilityDataModel[]>(
            this._url + 'GetGLLOInsightsCard',
            parameters,
            {
                headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
            }
        );
    }

    getGLRoleInsightsCard(parameters: IProfitabilityParams): Observable<IProfitabilityDataModel[]> {
        return this._http.post<IProfitabilityDataModel[]>(
            this._url + 'GetGLRoleInsightsCard',
            parameters,
            {
                headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
            }
        );
    }

    getGLLoanInsightsCard(parameters: IProfitabilityParams): Observable<IProfitabilityDataModel[]> {
        return this._http.post<IProfitabilityDataModel[]>(
            this._url + 'GetGLLoanInsightsCard',
            parameters,
            {
                headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
            }
        );
    }

    getLoanGLDetails(
        parameters: IProfitabilityParams
    ): Observable<IProfitabilityIncomeStatement[]> {
        return this._http.post<IProfitabilityIncomeStatement[]>(
            this._url + 'GetLoanGLDetails',
            parameters,
            {
                headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
            }
        );
    }

    getLoanDetailsByLoanNumber(
        parameters: IProfitabilityParams
    ): Observable<ILoanProfitabilitySummary> {
        return this._http.post<ILoanProfitabilitySummary>(
            this._url + 'GetLoanDetailsByLoanNumber',
            parameters,
            {
                headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
            }
        );
    }

    setLoanPrfitabilityDialogParams(
        params: IProfitabilityParams,
        //dialogReference: any,
        isLoanProfitabilityDialog = false
    ) {
        this.dialogParametrs = {
            isLoanProfitabilityDialog: isLoanProfitabilityDialog,
            params: params,
            dialogref: null, //dialogReference,
        };
    }

    openLoanProfitabilityDialog() {
        let dialogRef = this.dialog.open(LoanProfitabilityDialogComponent, {
            data: '',
        });
        this.dialogParametrs.dialogref = dialogRef;
        dialogRef.afterClosed().subscribe(() => {});
        //return dialogRef;
    }

    closeLoanProfitabilityDialog() {
        this.dialogParametrs?.dialogref?.close();
    }

    setHasRouteHistory(hasRouteHistory: boolean) {
        this.hasRouteHistory = hasRouteHistory;
    }

    getHasRouteHistory() {
        return this.hasRouteHistory;
    }

    setNavigationLinks(links) {
        this.routeHistoryData.navigationLinks = [...links];
    }

    setHierarchyParams(hierarchy: string, identifier: string, titlePart: string) {
        this.routeHistoryData.hierarchy = hierarchy;
        this.routeHistoryData.identifier = identifier;
        this.routeHistoryData.titlePart = titlePart;
    }

    getRouteHistoryData() {
        return this.routeHistoryData;
    }
}
